import {
  BOT_PRESSURE_DICE_LEAGUES,
  BOT_PRESSURE_FOCUS_LEAGUES,
  BOT_PRESSURE_LEAD_THRESHOLD,
} from "../../../configs/botPressure";

// Отрыв игрока от ближайшего конкурента по очкам победы. Конкуренты — ВСЕ
// остальные игроки, включая других живых: давление включает лидерство в
// партии, а не «живой впереди ботов»
const getLeadOverClosestRival = (player, players) => {
  const rivalPoints = players
    .filter((rival) => rival.id !== player.id)
    .map((rival) => rival.winPoints || 0);

  if (rivalPoints.length === 0) {
    return 0;
  }

  return (player.winPoints || 0) - Math.max(...rivalPoints);
};

/**
 * Пересчет защелок давления ботов НА СТАРТЕ РАУНДА (см. src/configs/botPressure.js).
 * Возвращает игроков с проставленными isUnderBotFocus / isUnderBotDicePressure.
 *
 * Признаки живут прямо на игроке, а не в отдельной ветке состояния: игроки —
 * реплицируемое общее состояние, поэтому подкрутку костей одинаково посчитает
 * любой исполнитель броска (сервер, клиент-делегат бота, клиент живого
 * игрока, считающий общий ближний бой), и они же переживают запись матча.
 *
 * Защелки только ВЗВОДЯТСЯ: снимать давление нельзя — включилось на старте
 * раунда, действует до конца матча, даже если игрок просел.
 */
export const applyBotPressureLatches = (players) => {
  if (!players || players.length === 0) {
    return players;
  }

  return players.map((player) => {
    // Боты друг друга не давят: гандикап адресован живым игрокам. leagueId
    // сервер проставляет только в рейтинговых партиях — в обычных, локальных
    // и в кампании давление не включается вовсе
    if (player.isBot || !player.leagueId) {
      return player;
    }

    const hasLead = getLeadOverClosestRival(player, players) >= BOT_PRESSURE_LEAD_THRESHOLD;

    // Одной лиги для фокуса мало: нужен отрыв от ближайшего конкурента. Пока
    // игрок идет вровень с остальными, боты играют против него как обычно
    const isUnderBotFocus = Boolean(player.isUnderBotFocus)
      || (hasLead && BOT_PRESSURE_FOCUS_LEAGUES.includes(player.leagueId));

    const isUnderBotDicePressure = Boolean(player.isUnderBotDicePressure)
      || (hasLead && BOT_PRESSURE_DICE_LEAGUES.includes(player.leagueId));

    if (isUnderBotFocus === Boolean(player.isUnderBotFocus)
      && isUnderBotDicePressure === Boolean(player.isUnderBotDicePressure)) {
      return player;
    }

    return {...player, isUnderBotFocus, isUnderBotDicePressure};
  });
};
